<sm-title-bar pageTitle="Uploaded documents" [backWithParams]="true" [headerCustomTemplate]="addButton">
  <ng-template #addButton>
    <!-- <button mat-button color="accent" (click)="onAddDocument()"> 
      <mat-icon class="material-icons-round try" [inline]="true" style="font-size: 30px !important;">add_circle</mat-icon>
    </button> -->
    <div class="create_btn_sd">
      <button mat-flat-button color="primary" mat-button aria-label="option menu" (click)="onAddDocument()">
          <mat-icon>add</mat-icon> 
          Document 
      </button>
  </div>
  </ng-template>
</sm-title-bar>

<!-- <mat-card *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="messageList" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="25">
      </sm-data-table>
    </div>
  </mat-card>

  <ng-template #menuTemplate let-rowvalue>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
     <mat-icon class="material-icons-outlined">info</mat-icon>
     <span>View Details</span>
   </button>
   <button mat-menu-item (click)="editDocument(rowvalue)">
     <mat-icon class="material-icons-outlined">edit</mat-icon>
     <span>Edit</span>
   </button>
   <button mat-menu-item (click)="deleteDocument(rowvalue)">
     <mat-icon class="material-icons-outlined">delete</mat-icon>
     <span>Delete</span>
   </button>
 </ng-template>
<ng-template #image let-objValue>
  <img
    [src]="
      objValue['documentThumbUrl'] !== null && objValue['documentThumbUrl'] !== 'null'
        ? objValue['documentThumbUrl']
        : './assets/images/documents.png'
    "
    class="img-fluid rounded-circle"
  />
</ng-template> -->
  
<div class="service_card_sedf" *ngIf="!loader && messageList.length > 0">
  <div class="row">
      <div class="col-sm-3" *ngFor="let item of messageList">
          <div class="serv_sect">
          <mat-card class="service-card">
        <mat-card-header class="hy_secf">
          <div mat-card-avatar class="header-avatar">
            <img [src]="item.documentThumbUrl" onerror="this.src='../../../../assets/images/document_placeholder.avif'" alt=""/>
          </div>
         
      </mat-card-header>
      <mat-card-content>
          <div class="header_ftgt">
            <button mat-icon-button [matMenuTriggerFor]="menu2" class="more-button" aria-label="More options">
              <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu2="matMenu">
            <!-- <button mat-menu-item (click)="viewDetails(item)">
              <mat-icon class="material-icons-outlined">info</mat-icon>
              <span>View Details</span>
            </button> -->
            <button mat-menu-item (click)="editDocument(item)">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteDocument(item)">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
              <mat-card-title>{{item.documentName}}
              </mat-card-title>
              <mat-card-subtitle>{{item.creationDate | date}}
              </mat-card-subtitle>

          </div>
      <div class="location_list_s">
        <div class="new_empol ccvvtheight" >
          <p class="ellipsis">{{item.documentDescription}}</p>
      </div>
      
      <div class="pio_no_download">
      <div class="new_empol">
          <p *ngIf="item.verificationStatus == 0"><mat-icon style=" color: #e60505">gpp_bad</mat-icon>{{item.verificationStat}}</p>
          <p *ngIf="item.verificationStatus == 1"><mat-icon>verified_user</mat-icon>{{item.verificationStat}}</p>
          <p *ngIf="item.verificationStatus == 2"><mat-icon style=" color: #FFC107">hourglass_top</mat-icon>{{item.verificationStat}}</p>
          <p *ngIf="item.verificationStatus == 3"><mat-icon style=" color: #919191">verified_user</mat-icon>{{item.verificationStat}}</p>
      </div>
      <div class="new_empol_download" (click)="downloadDoc(item.documentUrl)">
        <p><mat-icon>download</mat-icon>Download</p>
    </div>
  </div>
      </div>
      </mat-card-content>
  </mat-card>
</div>
</div>  


</div>
</div>


<!-- placeholder html start -->

 <div class="placeholder_started" *ngIf="!loader && messageList.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCka4FwusmLbLaS_GPxWiNCse8FAWEDsdIMA&s">
                 </div>
                 <mat-card-title>No document added yet</mat-card-title>
                 <mat-card-content>Once you upload the docs of your business/service, they'll appear here along with the verification status.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="onAddDocument()">
                        <mat-icon>add</mat-icon> 
                        Document
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/watchvideo.png">
                 </div>
                 <mat-card-title>How to uploaded documents?</mat-card-title>
                 <mat-card-content>Check our help document on creating a new business or professional service. You can check this video as well. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div> -->
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in uploading a document or if there's any issue with verification, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 

  <!-- placeholder html end -->





  
  